import ExportBase from "../exportbase";


import LabelDialog from "../../../../../dialogs/labeldialog";
import DialogInputBox from "../../../../../dialogs/inputbox";


import React from "react";

class ExportSRT extends ExportBase 
{


constructor(props)
{
    super(props);

    this.state.formulaire =
    {
        position:false,
        colors: false,
        bom: false,
    }
        
    this.positionRef = React.createRef();
    this.colorsRef = React.createRef();
    this.bomRef = React.createRef();


    this.onAssetDownloaded = this.onAssetDownloaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)


    this.ready = false;
    this.lastFormulaireSend = "";

}

componentDidMount()
{
    super.componentDidMount();
    
    
}

componentDidUpdate()
{
    super.componentDidUpdate()
    
}

createWorker()
{
    
    return new Worker(new URL('./srtworker.js', import.meta.url));
}

sendFormulaire()
{
    var datas = {};
    datas = {
        positions : this.positionRef.current.getValue(),
        colors :  this.colorsRef.current.getValue(),
        bom : this.bomRef.current.getValue(),
    }




    if (this.lastFormulaireSend !== JSON.stringify(datas))
    {
        this.lastFormulaireSend = JSON.stringify(datas);
            this.startComputeFile(datas)
    }

    
    
}


handleOnChange()
{
    
    if (this.ready) this.sendFormulaire();
};

onAssetDownloaded(asset)
{
   
    this.ready = true;

}

render()

{
    // <>{this.props.format}<br/>{this.props.type}<br/>{this.props.title}<br/>{this.props.asid}</>

    return super.render(

    <>
        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Type de fichier":"File type"}
        />

        <DialogInputBox
        value = {this.state.formulaire.colors}
        disabled={false}
        autoFocus = {false}
        ref = {this.colorsRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?"Inclure les couleurs":"With colors"}
        />

        <br/>

        <DialogInputBox
        value = {this.state.formulaire.position}
        disabled={false}
        autoFocus = {false}
        ref = {this.positionRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?"Inclure les positions":"With positions"}
        />



        <br/>

        <DialogInputBox
        value = {this.state.formulaire.bom}
        disabled={false}
        autoFocus = {false}
        ref = {this.bomRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?"Ajouter un B.O.M. au début du fichier":"Add B.O.M. at the start of file"}
        />



        <br/>
        <br/>
        
    </>
        
    )
}
}

export default ExportSRT;